import React, {useEffect, useState} from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {FormGroup, Icon, Loader} from '../components';
import ShowItem from "../ShowItem";
import Block, {Section} from "../Block";
import PurposeForm from "./PurposeForm";
import useActionConfirmation from "../useActionConfirmation";

export const PurposeModal = ({purpose,
                               show,
                               setShow,
                               updatePurpose,
                               addConsentable,
                               removeConsentable,
                               onCreate,
                               params,
                               isLoading,
                               isSuccess,
                               editable: propEditable = false, languages}) => {
  const { t } = useTranslation();
  const [editable, setEditable] = useState(false)
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess) }

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const handleClose = () => {
    setShow(false);
    setEditable(false)
  }

  useEffect(() => {
    show && setEditable(propEditable)
  },[propEditable, show])

  if (!purpose && !editable) {
    return <></>
  }

  const onUpdate = (data) => {
    updatePurpose({...params, purposeId: purpose.id, purpose: data}).unwrap().then(() => setEditable(false))
  }

  const onAdd = () => {
    confirm(() => addConsentable({...params, consentableType: purpose.type, consentableId: purpose.id}).unwrap().then(handleClose))
  }

  const onRemove = () => {
    confirm(() => removeConsentable({...params, consentableType: purpose.type, consentableId: purpose.id}).unwrap().then(handleClose))
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} size={"lg"}>
        <Modal.Body>
          <Loader {...loaderProps}>
            {!editable && <PurposeShow purpose={purpose} languages={languages}/>}
            {editable && <PurposeForm
              purpose={purpose}
              setSubmitButtonProps={setSubmitButtonProps}
              onSubmit={purpose ? onUpdate : onCreate}
              languages={languages}
            />}
          </Loader>
        </Modal.Body>
        {!isLoading && <Modal.Footer>
          <Button variant="secondary" onClick={() => editable && purpose ? setEditable(false) : handleClose()}>
            {t("cancel")}
          </Button>
          {!editable && purpose.editable && <Button onClick={() => setEditable(true)}>
            <Icon icon='edit' text={t("edit")}/>
          </Button>}
          {editable && <Button key="submit" type="submit" variant="primary" {...submitButtonProps}>
            <Icon icon='save' text={t("save")}/>
          </Button>}
          {!editable && purpose?.active && <Button onClick={onRemove} variant="primary">
            <Icon icon='trash' text={t("remove")}/>
          </Button>}
          {!editable && !purpose?.active && <Button onClick={onAdd} variant="primary">
            <Icon icon='plus' text={t("add")}/>
          </Button>}
        </Modal.Footer>}
      </Modal>
      <Confirmation {...confirmationProps} />
    </>
  );
}

function PurposeShow({purpose, languages}) {
  const { t } = useTranslation();

  return <>
    <div>
      {purpose.iabId && <ShowItem label={t("cmp.iabId")} value={purpose.iabId} darkBorder={true}/>}
      {purpose.iabId && <ShowItem label={t("cmp.iabType")} value={t(`cmp.${purpose.type}`)} darkBorder={true}/>}
      {!purpose.iabId && <ShowItem label={t("cmp.key")} value={purpose.key} darkBorder={true}/>}
      {purpose.type == 'purpose' && <ShowItem label={t("cmp.legIntAllowed")} value={t(purpose.legInt)} darkBorder={true} className={"mb-2"}/>}
    </div>
    {languages.map( language => {
      return <Block key={language} title={t(`languages.${language}`)}>
        {purpose.content?.filter( p => p.language == language)?.map( p => {
          return <ShowItem key={p.name} label={t(`cmp.${p.name}`)} value={p.content} />
        })}
      </Block>
    })}
  </>
}
